export const LOCAL_STORAGE_ITEM = "security-events-last-search";
export const TIME_UNITS = ["DAYS", "HOURS", "MINUTES", "SECONDS"];
export const SECURITY_EVENT_STATUSES = {
  NEW: "New",
  INVESTIGATING: "Investigating",
  FALSE_POSITIVE: "False Positive",
  CLOSED: "Closed"
};
